export function getdata() {
	let obj = {
		headData: [{
			title: '项目名称',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '规格型号',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '单位',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '数量',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '单价',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '金额',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '税率/征收率',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, {
			title: '税额',
			prop: 'tes1',
			width: '220',
			ssort: true
		}, ]

	}
	return obj
}
